/* eslint quotes: 0 */
export default {
  "container": {
    "containerSearchInProgress": "Containersuche läuft",
    "noContainersWithSufficientProductQuantityFound": "Es wurden keine Container mit ausreichenden Mengen des ausgewählten Produkts gefunden.",
    "searchForProductInContainers": "Produkt in Containern suchen"
  },
  "contractor": {
    "acceptanceDate": "Abnahmedatum",
    "all": "Alle",
    "chooseContractor": "Wählen Sie einen Auftragsnehmer",
    "chooseEndedStatus": "Nur abgeschlossene Aufträge anzeigen?",
    "chooseSettlementStatus": "Abrechnungsstatus auswählen",
    "contractor": "Auftragnehmer",
    "dateOfSampleAndAcceptance": "Prüf- und Abnahmedatum",
    "listOfContractorsWorksToBeSettled": "Liste der abzurechnenden Arbeiten der Auftragnehmer",
    "makeSettlementErrorText": "Abrechnung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "noItemsToBeSettled": "Keine Einträge zur Abrechnung",
    "onlyEnded": "Nur abgeschlossen",
    "serviceCost": "Kosten für Dekoration",
    "toBeSettled": "Noch ausstehende Abrechnung",
    "unitPrice": "Preis pro Einheit"
  },
  "contractorsSettlementsImportPopup": {
    "importSuccessDesc": "Daten aus der XLSX-Datei  wurden importiert",
    "importSuccessTitle": "Importierte Daten",
    "importTitle": "Importiere die Liste der abzurechnenden Arbeiten der Auftragnehmer",
    "importXlsx": "XLSX-Datei importieren",
    "xlsxFile": "XLSX-Datei"
  },
  "customer": {
    "addAddress": "Adresse hinzufügen",
    "addAddressErrorText": "Das Hinzufügen der Adresse ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "addAddressSuccessText": "Die angegebene Adresse wurde gespeichert",
    "addAddressSuccessTitle": "Die Adresse wurde hinzugefügt",
    "addContactPerson": "Den Ansprechpartner hinzufügen",
    "addContactPersonErrorText": "Das Hinzufügen des Ansprechpartners ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "addContactPersonSuccessText": "Der angegebene Ansprechpartner wurde gespeichert",
    "addContactPersonSuccessTitle": "Der Ansprechpartner wurde hinzugefügt",
    "addCustomer": "Den Kunden hinzufügen",
    "addCustomerErrorText": "Das Hinzufügen des Kunden ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "addCustomerSuccessText": "Der angegebene Kunde wurde gespeichert",
    "addCustomerSuccessTitle": "Der Kunde wurde hinzugefügt",
    "addErrorText": "Client konnte nicht hinzugefügt werden.",
    "addNewCustomer": "Einen neuen Kunden hinzufügen",
    "addSuccessText": "Auf Basis der bereitgestellten Daten wurde ein Kunde erstellt.",
    "addSuccessTitle": "Der Kunde wurde hinzugefügt",
    "addingContactPersonAvailableAfterCustomerSave": "Das Hinzufügen von Ansprechpartnern ist möglich, sobald der Kunde gespeichert ist.",
    "addingNewCustomer": "Hinzufügen eines neuen Kunden",
    "addingShippingAddressAvailableAfterCustomerSave": "Das Hinzufügen von Postadressen zu der Sendung ist möglich, sobald der Kunde gespeichert ist.",
    "addingTransaltionsAvailableAfterCustomerSave": "Das Hinzufügen von Übersetzungen ist möglich, sobald der Kunde gespeichert ist.",
    "building": "Gebäude",
    "buildingNumber": "Gebäude- Nr.",
    "changePassword": "Passwort ändern",
    "changeYourPassword": "Ändern Sie Ihr Passwort",
    "city": "Stadt",
    "company": "Unternehmen",
    "companyName": "Name des Unternehmens",
    "contact": {
      "contact": "Kontakt"
    },
    "contactAddress": "Kontaktadresse",
    "contactPeople": "Ansprechpartner",
    "correspondenceAddressSet": "Daten geändert",
    "correspondenceAddressSetDesc": "Postanschrift festgelegt",
    "correspondenceInfo": "Kontaktdaten",
    "customerCountryQuestionMark": "Land des Kunden?",
    "customerLogo": "Kunden-Logo",
    "customers": "Kunden",
    "customersList": "Liste der Kunden",
    "deleteAddressConfirmTitle": "Sind Sie sicher, dass Sie diese Adresse löschen wollen?",
    "deleteAddressErrorText": "Die Löschung der Adresse ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "deleteAddressSuccessText": "Die ausgewählte Adresse wurde gelöscht",
    "deleteAddressSuccessTitle": "Adresse gelöscht",
    "deleteContactPersonConfirmTitle": "Sind Sie sicher, dass Sie diesen Ansprechpartner löschen möchten?",
    "deleteContactPersonErrorText": "Die Löschung des Ansprechpartners ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "deleteContactPersonSuccessText": "Der ausgewählte Ansprechpartner wurde gelöscht",
    "deleteContactPersonSuccessTitle": "Ansprechpartner gelöscht",
    "discount": {
      "deliveryDiscount": "Lieferrabatt",
      "productDiscount": "Rabatt auf Produkte",
      "servicesDiscount": "Rabatt auf Dekorationen"
    },
    "edit": "Den Kunden bearbeiten",
    "editAddress": "Die Adresse bearbeiten",
    "editAddressErrorText": "Die Bearbeitung der Adresse ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "editAddressSuccessText": "Die angegebene Adresse wurde geändert",
    "editAddressSuccessTitle": "Adresse geändert",
    "editClientErrorText": "Die Bearbeitung der Kundendaten ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "editClientSuccessText": "Die Kundendaten wurden geändert",
    "editClientSuccessTitle": "Der Kunde wurde geändert",
    "editContactPerson": "Die Daten des Ansprechpartners bearbeiten",
    "editContactPersonErrorText": "Bearbeitung der Daten des Ansprechpartners ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "editContactPersonSuccessText": "Die Daten des angegebenen Ansprechpartners wurden geändert",
    "editContactPersonSuccessTitle": "Der Ansprächpartner wurde geändert.",
    "editPasswordErrorText": "Die Passwortänderung ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "editPasswordSuccessText": "Das Passwort wurde geändert",
    "editPasswordSuccessTitle": "Passwort geändert",
    "enterCustomerData": "Bitte die Kundendaten eingeben",
    "fountAddresses": "Gefundene Adressen:",
    "getDataFromGUS": "Daten aus GUS abrufen",
    "getDataFromVIES": "Daten aus VIES abrufen",
    "houseNumber": "Hausnummer",
    "invoiceAddressSet": "Daten geändert",
    "invoiceAddressSetDesc": "Rechnungsdaten wurden festgelegt",
    "invoiceAndCorrespondenceAddressSet": "Daten geändert",
    "invoiceAndCorrespondenceAddressSetDesc": "Rechnungs- und Korrespondenzdaten wurden festgelegt",
    "invoiceInfo": "Rechnungsdaten",
    "invoiceName": "Name auf der Rechnung",
    "isOrdersInRpogress": "Offene Aufträge?",
    "maxAddressSearchResults": "Es werden maximal 50 übereinstimmende Adressen angezeigt. Wenn Sie die gewünschte Adresse nicht finden, schränken Sie Ihre Suchkriterien ein.",
    "newsletterAgreement": "Einwilligungerklärung zum Erhalt eines Newsletters",
    "noAddressesToDisplay": "Keine Adressen zum Anzeigen vorhanden",
    "noContactPeopleToDisplay": "Keine Ansprechpartner zum Anzeigen vorhanden",
    "noCustomerMarchingPhraseFound": "Es wurden keine zum Suchbegriff passenden Kunden gefunden",
    "noCustomersToDisplay": "Es konnten keine Kunden gefunden werden",
    "noTranslationsForThisClient": "Keine Übersetzungen für diesen Kunden vorhanden",
    "notFoundInVIESGUSText": "Das angegebene Unternehmen wurde in der Datenbank nicht gefunden",
    "notFoundInVIESGUSTitle": "Nicht gefunden",
    "offersInProgress": "Ausstehende Angebote",
    "ordersAndOffers": "Aufträge und Angebote",
    "ordersInProgress": "Ausstehende Aufträge",
    "passowrdChange": "Passwort ändern",
    "person": "Person",
    "phoneShortCap": "Tel.",
    "profile": "Profil",
    "removeCustomerConfirmTitle": "Sind Sie sicher, dass Sie diesen Kunden löschen möchten?",
    "removeCustomerErrorText": "Die Löschung des Kunden ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "removeCustomerSuccessText": "Der ausgewählte Kunde wurde gelöscht",
    "removeCustomerSuccessTitle": "Kunde gelöscht",
    "removeLogo": "Firmenlogo löschen",
    "searchAddressesByCompanyNameAddressOrContactInfo": "Suche nach Adressen über den Firmennamen, die Adresse oder Kontaktangaben",
    "selectCustomer": "Kunden auswählen",
    "shippingInfo": "Details zum Versand",
    "showCustomerDrafts": "Angebote anzeigen",
    "showCustomerOrders": "Bestellungen anzeigen",
    "statistics": "Statistiken",
    "stockReportsNotifications": "Lagerbestandsbenachrichtigungen",
    "street": "Straße",
    "telephone": "Telefon",
    "termsOfSale": "Verkaufsbedingungen",
    "unsettledInvoices": "Ausstehende Rechnungen",
    "vatIDNumber": "Steuer-IdNr. / USt-IDNr.",
    "verificationIntegrationDisabledDesc": "Der Datenabrufdienst ist derzeit nicht verfügbar",
    "verificationIntegrationDisabledTitle": "Dienst nicht verfügbar",
    "withOrdersInProgress": "inklusive offener Aufträge",
    "withoutOrdersInProgress": "Keine offenen Aufträge",
    "youMustSelectCountryPrefix": "Wählen Sie den Ländercode aus",
    "youMustSelectCountryPrefixDesc": "Um Daten abzurufen, muss ein Ländercode angegeben werden",
    "yourAccount": "Ihr Konto",
    "zipCode": "Postleitzahl"
  },
  "customerOrdersPopup": {
    "offers": "Kundenangebote",
    "orders": "Kundenaufträge"
  },
  "dashboard": {
    "customersPopup": {
      "customerEmail": "E-Mail",
      "customerName": "Name des Kunden",
      "customerPhone": "Telefon",
      "title": "Anfragen an Kunden senden"
    }
  },
  "errorPage": {
    "errorCode": "Fehlercode 404",
    "pageDoesNotExist": "Die ausgewählte Webseite existiert nicht",
    "tryAgainLaterOrContactAdministrator": "Versuchen Sie es später noch einmal oder wenden Sie sich an Ihren Systemadministrator."
  },
  "inquiries": {
    "addComments": "Fügen Sie Ihre Anmerkungen hinzu",
    "addFirstProductInstructionInfo": "Fügen Sie Ihr erstes Produkt hinzu, indem Sie auf „+ Produkt“ klicken",
    "addFirstServiceInstructionInfo": "Fügen Sie Ihre erste allgemeine Dekoration hinzu, indem Sie auf „+ Allgemeine Dekoration“ klicken.",
    "caanotCreateOrder": "Die Bestellung kann nicht erstellt werden",
    "executionTime": "Bearbeitungszeit",
    "failedToAddProductsToOrder": "Es wurden keine Produkte zu der Bestellung hinzugefügt.",
    "globalServicesTooltip": "Wenn mehrere Produkte die gleiche Dekoration bekommen sollen, fügen Sie von hier aus Ihre allgemeine Dekoration hinzu. Die Kosten für die Dekorationsgestaltung werden dann nur einmal berechnet. Anschließend können Sie die Anzahl der bestellten Dekorationen auf die einzelnen Produkte aufteilen.",
    "needExecutionTill": "Der Auftrag muss ausgeführt worden sein bis",
    "noComments": "Keine Anmerkungen",
    "noDateSelected": "Keine Frist",
    "orderAdditionalInfo": "Zusätzliche Anmerkungen zum Auftrag",
    "selectExecutionTime": "earbeitungszeit auswählen",
    "trackingNumber": "Tracking-Nummer",
    "unexpectedErrorOccured": "Es ist ein unerwartetes Problem aufgetreten"
  },
  "login": {
    "authError": "Autorisierungsfehler. Bitte versuchen Sie es erneut",
    "emailPlaceholder": "Ihre E-Mail Adress",
    "loginInProgress": "Anmeldung läuft ...",
    "loginLabel": "Einloggen",
    "password": "Passwort",
    "passwordPlaceholder": "********",
    "register": "Sie haben kein Konto?",
    "resetPassword": "Passwort vergessen?"
  },
  "noPermissions": {
    "noPermissionsDescription": "Wenn Sie den Verdacht haben, dass dies ein Fehler ist, wenden Sie sich bitte an Ihren Systemadministrator.",
    "noPermissionsText": "Sie sind nicht berechtigt, diese Seite zu sehen",
    "noPermissionsTitle": "Keine Berechtigung vorhanden"
  },
  "order": {
    "addNewDraft": "Neues Angebot hinzufügen",
    "addNewFemenine": "Neu hinzufügen",
    "addNewOrder": "Neuen Auftrag hinzufügen",
    "addNewShippingAddress": "Neue Lieferadresse hinzufügen",
    "addedProducts": "Die folgenden Produkte wurden hinzugefügt:",
    "addressRemoved": "Die zuvor verwendete Adresse wurde gelöscht. Bitte wählen Sie eine neue Adresse.",
    "awaitingInvoice": "Anzahl der Kunden, die auf eine Rechnung warten",
    "awaitingProductionComplete": "Anzahl der Kunden, die auf den Produktionsabschluss warten",
    "awaitingSample": "Anzahl der Kunden, die ein Produktmuster warten",
    "awaitingSampleAcceptance": "Anzahl der Kunden, auf die Abnahme des Produktmusters warten",
    "beeingCollected": "Derzeit in der Bearbeitung",
    "blockade": "Sperre",
    "cartonsMissingInfo": "Die Anzahl der Kartons ist ggf. anzupassen, da einige Produkte die zuvor festgelegte Stückzahl pro Karton nicht haben.",
    "cartonsNumber": "Anzahl der Kartons",
    "checkFormDesc": "Bei der Validierung wurden Fehler gefunden, die korrigiert werden müssen. Bitte überprüfen Sie die Registerkarten des Formulars und korrigieren Sie die gefundenen Fehler.",
    "checkFormTitle": "Bitte überprüfen Sie das Formular",
    "chooseShippingAddress": "Wählen Sie die Lieferadresse",
    "clientContactPerson": "Ansprechpartner des Kunden",
    "connectedInvoices": "Zusammenhängende Rechnungen",
    "currentDiscountOfCustomer": "er im Kundenprofil gespeicherte Rabatt beträgt",
    "customerAndName": "Kunde und Name",
    "customerDiscounts": "Kundenrabatte",
    "dashOrderAwaitingShipping": "- Aufträge, die auf den Versand warten",
    "dashReadyForShipping": "bereit für den Versand",
    "dateOfIssue": "Ausstellungsdatum",
    "deleted": "Gelöscht",
    "delivery": "Lieferung",
    "download": "Herunterladen",
    "downloadPDF": "PDF-Datei herunterladen",
    "downloadPDFforMe": "Angebot für mein UNTERNEHMEN",
    "downloadPDFforMyCustomer": "Angebot für meinen KUNDEN",
    "downloadXls": "XLS-Datei herunterladen",
    "draftDeleteConfirmTitle": "Sind Sie sicher, dass Sie dieses Angebot löschen möchten?",
    "draftDeleteErrorText": "Die Löschung des Angebots ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "draftDeleteSuccessText": "Das ausgewählte Angebot wurde gelöscht",
    "draftDeleteSuccessTitle": "Angebot gelöscht",
    "draftsList": "Liste der Angebote",
    "duplicateOrder": {
      "questionTextOffer": "Sind Sie sicher, dass Sie ein ausgewähltes Angebot duplizieren möchten?",
      "questionTextOrder": "Sind Sie sicher, dass Sie den ausgewählten Auftrag duplizieren möchten?",
      "questionTitle": "Den Vorgang bestätigen",
      "successTextOffer": "Das ausgewählte Angebot wurde erfolgreich dupliziert",
      "successTextOrder": "Der ausgewählte Auftrag wurde erfolgreich dupliziert",
      "successTitleOffer": "Angebot dupliziert",
      "successTitleOrder": "Auftrag dupliziert"
    },
    "editDraft": "Angebot bearbeiten",
    "editDraftErrorText": "Das Angebot konnte nicht gespeichert werden",
    "editDraftSaveSuccessText": "Das Angebot wurde erfolgreich gespeichert",
    "editDraftSuccessTitle": "Angebot gespeichert",
    "editingOfferFromHPL1": "Sie bearbeiten ein Angebot, das für <strong>Ihr UNTERNEHMEN</strong> erstellt wurde. Wenn Sie es in ein <strong>Angebot für Ihren KUNDEN</strong> umwandeln möchten, klicken Sie ",
    "editingOfferFromHPL2": "hier",
    "editingOfferFromHPL3": "Denken Sie daran, das Angebot nach dieser Änderung zu speichern.",
    "ended": "Beendet",
    "errors": {
      "shipping_price_not_fetched": "Der Lieferpreis konnte nicht aktualisiert werden. Bitte überprüfen Sie den Lieferpreis."
    },
    "fileSuffixOfferCustomer": "-ANGEBOT-KUNDE",
    "fileSuffixOfferMe": "-ANGEBOT-HPL",
    "files": {
      "addingFile": "Datei hinzufügen",
      "deleteFile": "Datei löschen",
      "editFile": "Datei bearbeiten",
      "editFileText": "Die aktualisierte Dateibeschreibung eingeben",
      "editFileTitle": "Dateibeschreibung ändern",
      "fileEditError": "Beim Bearbeiten der Datei ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
      "noFilesToDisplay": "Diesem Auftrag sind keine Dateien zugeordnet",
      "noServiceFilesToDisplay": "Keine Dateien vorhanden, die mit dieser Dekoration verknüpft sind",
      "removeFileDesc": "Diese Aktion kann nicht rückgängig gemacht werden",
      "removeFileTitle": "Sind Sie sicher, dass Sie diese Datei löschen möchten?",
      "title": "Diesem Auftrag zugeordnete Dateien",
      "uploadError": "Beim Hinzufügen der Datei ist ein Fehler aufgetreten"
    },
    "forAcceptance": "Bereit zur Abnahme",
    "inProduction": "In der Produktion",
    "includedCustomerDiscount": "Kundenrabatt",
    "includedMarkup": "Aufschlag",
    "invoicesIssued": "Ausgestellte Rechnungen",
    "lastChange": "letzte Änderung",
    "lastItemModified": "Zuletzt geändert",
    "lastItemViewed": "Zuletzt angesehen",
    "nameCheck": {
      "inProgress": "Auftragsbezeichnung prüfen",
      "inUse": "Die ausgewählte Auftragsbezeichnung wird bereits für andere Aufträge verwendet.",
      "isAvailable": "Die gewählte Auftragsbezeichnung ist verfügbar"
    },
    "noAddressFound": "Die ausgewählte Adresse konnte nicht gefunden werden",
    "noAddresses": "Keine Adressen vorhanden",
    "noAddressesForThisClient": "Keine dem Kunden zugeordneten Adressen.",
    "noContactPeople": "Keine Ansprechpartner vorhanden",
    "noInvoicesConnectedToOrder": "Keine diesem Auftrag zugeordneten Rechnungen",
    "nonExistingCustomerText": "Der Kunde, der diesem Auftrag zugeordnet war, wurde gelöscht. Bitte weisen Sie dem Auftrag erneut einen Kunden zu.",
    "nonExistingCustomerTitle": "Der ausgewählte Kunde existiert nicht",
    "noOffersOrOrdersToDisplay": "Keine Angebote oder Aufträge zum Anzeigen",
    "noOrderMatchingPhraseFound": "Keine zum angegebenen Suchbegriff passenden Aufträge",
    "noTagsMatchingGivenPhrase": "Keine zum eingegebenen Suchbegriff passenden Eigenschaften",
    "number": "Nummer",
    "numberOfOrderdProducts": "Anzahl der bestellten Produkte",
    "offerCurrency": "Angebotswährung",
    "offerLanguage": "Angebotssprache",
    "offerPreparedFor": "Angebot vorbereitet für",
    "offerSubmissionDate": "Datum der Angebotsaufgabe",
    "offersToCheck": "Angebote, die zu prüfen sind",
    "orderNumber": "Auftragsnummer",
    "orderPreparedFor": "Bestellung vorbereitet für",
    "orderPreview": "Auftragsvorschau",
    "orders": "Aufträge",
    "ordersList": "Auftragsliste",
    "ordersXlsFilename": "XLS-Dateiname des Auftrags",
    "paymentDate": "Zahlungsdatum",
    "paymentDeadline": "Zahlungsfrist",
    "pdfDownloadNoticeDesc": "Sie laden ein PDF-Angebot für sich selbst herunter. Geben Sie diese Datei nicht an Ihren Kunden weiter.",
    "pdfDownloadNoticeTitle": "Achtung!",
    "pendingPayment": "Ausstehende Zahlung",
    "priceChangePopup": {
      "changeSource": "Quelle der Änderung",
      "element": "Posten",
      "new": "Neuer Wert",
      "previous": "Vorheriger Wert",
      "sources": {
        "prices": "HPL-Preisliste",
        "customer_prices": "Ihre Preisliste"
      },
      "subtitle": "Diese Änderungen werden nach dem erneuten Speichern des Angebots übernommen",
      "title": "Es wurden folgende Preisänderungen vorgenommen",
      "type": "Art der Änderung",
      "types": {
        "globalServiceMultipleFrom": "Multiplikator für  die allgemeine Dekoration",
        "globalServicePrice": "Preis für die allgemeine Dekoration",
        "globalServiceSetupPrice": "Preis für die Einrichtung einer allgemeinen Dekoration",
        "product": "Produkt",
        "serviceMultipleFrom": "Dekorationsmultiplikator",
        "servicePrice": "Dekorationspreis",
        "serviceSetupPrice": "Preis für die Einrichtung einer Dekoration"
      }
    },
    "productMinQty": "Mindestmenge",
    "productsTags": "Produkteigenschaften",
    "readyForShipping": "Versandfertig",
    "saveAsOrder": "Auftrag zur Bearbeitung weiterleiten",
    "saveAsOrderNoticeDesc": "Einmal als Auftrag gespeichert, können die Daten nicht mehr bearbeitet werden - bitte vergewissern Sie sich, dass alle Daten korrekt eingegeben wurden.",
    "saveAsOrderNoticeTitle": "Den Auftrag zur Bearbeitung weiterleiten",
    "saveDraft": "Angebot speichern",
    "see": "Zur Ansicht",
    "selectOrder": "Auftrag auswählen",
    "sent": "Gesendet",
    "servicesGenitive": "Dekoration",
    "shippingAddress": "Lieferadresse",
    "showAddress": "Adresse anzeigen",
    "showContact": "Kontakt anzeigen",
    "summary": "Zusammenfassung",
    "toCheckInWarehouse": "Zu prüfen, ob auf Lager vorrätig",
    "toCollect": "Sammeln",
    "toDelete": "Zu löschen",
    "totalCost": "Gesamtkosten",
    "totalDeliveryCostNet": "Lieferkosten (netto)",
    "useCustomerDiscounts": "Kundenrabatte verwenden",
    "usePartnerPricing": "Verwenden Sie Ihre Preisliste für diese Bestellung",
    "valueForPartnerCustomer": "Auftragswert für den Kunden",
    "waitingForShipping": "Wartet auf Versand",
    "waitingPurchaseProducts": "Wartet auf Produkte",
    "whoOrders": "Auftraggeber",
    "whoOrdersMe": "Mein UNTERNEHMEN",
    "whoOrdersMyCustomer": "Mein KUNDE",
    "withDeadlineApproaching": "bei denen die Frist bald abläuft ",
    "yesSave": "Ja, speichern",
    "yourDiscounts": "Ihre Rabatte",
    "yourPrice": "Ihr Preis"
  },
  "price": {
    "addNewPrice": "Neuen Preis hinzufügen",
    "addNewProductPrice": "Neuen Produktpreis hinzufügen",
    "addNewServicePrice": "Neuen Dekorationspreis hinzufügen",
    "addNewSetupPrice": "Neuen Setup-Preis hinzufügen",
    "addPrice": "Preis hinzufügen",
    "addPriceErrorText": "Das Hinzufügen des Preises ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "addPriceSuccessText": "Der eingegebene Preis wurde gespeichert",
    "addPriceSuccessTitle": "Preis hinzugefügt",
    "bruttonPrice": "Bruttopreis",
    "chosenPriceIsSetupPrice": "Der eingegebene Preis ist ein Setup-Preis",
    "deletePriceConfirmTitle": "Sind Sie sicher, dass Sie diesen Preis löschen möchten?",
    "deletePriceErrorText": "Das Löschen des Preises ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "deletePriceSuccessText": "Der ausgewählte Preis wurde gelöscht",
    "deletePriceSuccessTitle": "Preis gelöscht",
    "differentPriceMultipleFromInfo": "Der angewendete Preismultiplikator \"pro Stück ab\" unterscheidet sich vom aktuellen Preismultiplikator ({value} Stk.)",
    "editPrice": "Preis bearbeiten",
    "export": "Exportieren",
    "exportPrices": "Preislisten exportieren",
    "exportSuccessfull": "Preislisten exportiert",
    "exportSuccessfullDesc": "Die Preislisten wurden erfolgreich exportiert",
    "importPrices": "Preislisten importieren",
    "importSuccessfull": "Preislisten importiert",
    "importSuccessfullDesc": "Die Preislisten wurden erfolgreich importiert",
    "includeSetupPrices": "Setup-Preise einbeziehen",
    "isSale": "Ausverkauf",
    "noPricesFoundForServiceGroup": "Keine Preislisten für die ausgewählte Dekorationgruppe gefunden",
    "noPricesToDisplay": "Keine Preise zum Anzeigen",
    "onlyPriceUpdate": "Nur Preisaktualisierung",
    "pln": "PLN",
    "plnBrutto": "PLN brutto",
    "plnNet": "PLN netto",
    "plnVat": "PLN MwSt.",
    "price": "Preis",
    "priceFlat": "Pauschale",
    "priceBox": "Staffelpreis nach Menge",
    "price25pcs": "bis 25 Stk.",
    "priceFirstBox": "Erster Karton",
    "priceSecondBox": "Zweiter Karton",
    "priceNextBox": "Nächster Karton",
    "priceBeforeDicount": "Preis vor Rabatt",
    "priceEdit": "Preisbearbeitung",
    "priceFrom": "Preis ab",
    "priceImportFrom": "Preisimport aus",
    "priceNet": "Nettopreis",
    "pricePerItem": "Preis pro Stück",
    "pricePerItemFrom": "Preis pro Stück ab {price} Stk.",
    "pricePerItemShort": "Preis pro Stk.",
    "prices": "Preise",
    "priceTo": "Preis bis",
    "pricesLists": "Preislisten",
    "pricesListsLowCase": "preislisten",
    "productGenitive": "des Produkts",
    "productsPricesList": "Produktpreisliste",
    "quantityFrom": "Menge ab",
    "quantityTo": "Menge bis",
    "removeAndReplacePrices": "Preise löschen und neu hinzufügen",
    "savePriceErrorText": "Das Bearbeiten des Preises ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "savePriceSuccessText": "Der ausgewählte Preis wurde geändert",
    "savePriceSuccessTitle": "Preis geändert",
    "seePricelist": "Preisliste anzeigen",
    "serviceGenitive": "die Dekoration",
    "servicesPriceList": "Preisliste für Dekorationen",
    "servicesPricesList": "Liste die Dekoration Preise",
    "setup": "Setup",
    "setupPricesList": "Setup-Preisliste",
    "supplierPricesFileNamePrefix": "lieferanten-preislisten-",
    "unitPricesIn": "Stückpreise in",
    "vat": "MwSt.",
    "vatRate": "MwSt.-Satz",
    "xlsxFileWithPrices": "XLSX-Datei mit Preisen"
  },
  "product": {
    "addGlobalService": "Allgemeine Dekoration",
    "addGlobalServicesPackage": "Dekorationspaket",
    "addProduct": "Produkt",
    "breakProductsIntoSeparateOffers": "Produkte in separate Angebote aufteilen",
    "checkAvailability": "Die bevorstehenden Lieferungen einsehen",
    "enterAdditionalProductDescriptionOptional": "Zusätzliche Produktbeschreibung eingeben (optional)",
    "enterProductNameOrCode": "Geben Sie den Produktnamen oder -code ein",
    "globalServices": "Allgemeine Dekoration",
    "noProductsMatchingGivenPhrase": "Keine Produkte, die dem angegebenen Suchbegriff entsprechen",
    "notIncludedInDiscounts": "Nicht rabattfähig",
    "product": "Produkt",
    "productCode": "Produktcode",
    "productName": "Produktbezeichnung",
    "products": "Produkte",
    "productsCodes": "Produkt-Codes",
    "selectProduct": "Wählen Sie ein Produkt",
    "totalBeforeDiscount": "Vor dem Rabatt",
    "totalMarkup": "Einschließlich Aufschlag",
    "totalProductsCostNet": "Produktkosten (netto)",
    "totalServicesCostNet": "Dekorationskosten (netto)",
    "useCustomPartnerPrice": "Verwenden Sie Ihren eigenen Preis",
    "useDefaultPartnerPrice": "Standardpreis verwenden"
  },
  "purchase": {
    "addOrderErrorText": "Das Hinzufügen des Auftrags ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "editOrderSuccessTitle": "Der Auftrag wurde gespeichert",
    "fileDeletedDesc": "Die ausgewählte Datei wurde gelöscht",
    "fileDeletedTitle": "Datei gelöscht",
    "numberOfPiecesNeeded": "Benötigte Stückzahl",
    "removeFileInProgress": "Datei wird gelöscht",
    "yourOrderSaveSuccessText": "Ihr Auftrag wurde gespeichert"
  },
  "register": {
    "customerTaxNumber": "USt-IdNr. / Steuernummer",
    "login": "Einloggen",
    "password": "Passwort",
    "passwordConfirmation": "Passwort wiederholen",
    "passwordReset": {
      "error": "Passwortänderung fehlgeschlagen",
      "resetLabel": "Passwort ändern",
      "resetInProgress": "Änderungen werden gespeichert",
      "success": "Passwort geändert – Sie können sich jetzt einloggen",
      "title": "Passwort ändern"
    },
    "passwordResetRequest": {
      "error": "Passwort-Reset fehlgeschlagen",
      "resetInProgress": "Passwort wird zurückgesetzt",
      "resetLabel": "Passwort-Reset anfordern",
      "success": "Passwort-Reset angefordert. Wenn die angegebene E-Mail-Adresse im System existiert, erhalten Sie weitere Anweisungen in Ihrem Posteingang.",
      "title": "Passwort zurücksetzen"
    },
    "registerError": "Registrierung fehlgeschlagen",
    "registerInProgress": "Registrierung läuft",
    "registerLabel": "Registrieren",
    "registerSuccess": "Konto erstellt. Es wartet auf die Überprüfung und Genehmigung.",
    "title": "Konto erstellen"
  },
  "service": {
    "addService": "Dekoration",
    "addServicesPackage": "Dekorationspaket",
    "addServicesPackageBtn": "Dekorationspaket hinzufügen",
    "chooseEmbroideryPosition": "Wählen Sie die Position der Dekoration",
    "chooseEmbroideryType": "Bitte wählen Sie die Art der Dekoration",
    "chooseService": "Wählen Sie bitte die Dekoration",
    "chooseServiceGroup": "Dekoration Gruppe auswählen",
    "commonServices": "Gemeinsame Dekorationen",
    "complexity": "Komplexitätsgrad",
    "descriptionFoCustomer": "Beschreibung für  den Kunden",
    "detailsOfServiceInOrder": "Details zur Dekoration in Ihrem Auftrag",
    "downloadLogo": "Firmenlogo herunterladen",
    "dstNumber": "DST-Nummer",
    "embroidery": {
      "colors": "Dekorationsfarben",
      "height": "HÖHE",
      "position": "Position der Dekoration",
      "size": "Dekorationsgröße (mm)",
      "type": "Art der Dekoration",
      "width": "BREITE"
    },
    "enterServiceNameOrCode": "Geben Sie den Namen oder Code der Veredelung ein",
    "files": {
      "title": "Dekorations-Dateien"
    },
    "findService": "Finden Sie eine passende Dekoration",
    "noServiceGroupsMatchingPhrase": "Es gibt keine Dekorationsgruppen, die dem angegebenen Ausdruck entsprechen.",
    "noServicesMatchingPhrase": "Keine zu dem angegebenen Suchbegriff passende Dekorationen",
    "productionCompleteDate": "Datum der Fertigstellung der Produktion",
    "sample": {
      "sampleAcceptDate": "Datum der Musterabnahme",
      "sampleDate": "Datum der Fertigung des Musters",
      "samplePhotosDateCreated": "Hinzugefügt am",
      "samplePhotosDownload": "Herunterladen",
      "samplePhotosDownloadAll": "Alle herunterladen",
      "samplePhotosSeePreview": "Bild des Musters ansehen",
      "samplePhotosTitle": "Musterfotos",
      "sampleReceiveDate": "Datum der Fertigstellung des Musters"
    },
    "sampleFiles": {
      "title": "Muster-Dateien"
    },
    "samples": {
      "noSamples": "Keine Muster vorhanden",
      "rejectReason": "Grund für die Ablehnung",
      "sample": "Muster",
      "saveBeforeAddingFiles": "Auftrag speichern, um Dateien hinzufügen zu können",
      "statuses": {
        "accepted": "Angenommen",
        "rejected": "Abgelehnt"
      },
      "title": "Dekorationsmuster"
    },
    "selectFileWithLogo": "Logodatei auswählen",
    "selectService": "Dekoration auswählen",
    "selectedServiceName": "Ausgewählte Veredelung",
    "service": "Dekoration",
    "serviceCode": "Dekoration Code",
    "serviceGroup": "Dekorationskategorie",
    "serviceName": "Dekorationsbezeichnung",
    "serviceNotFound": "Dekoration nicht gefunden",
    "serviceNotFoundDesc": "Für die ausgewählte Dekorationsgruppe, den Komplexitätsgrad und die angegebenen Maße wurden keine passenden Dekorationen gefunden. Bitte versuchen Sie es mit einer anderen Konfiguration.",
    "servicesPackage": {
      "dates": {
        "date": "Termin",
        "types": {
          "obtaining_at": "Datum des Mustererhalts",
          "accepted_at": "Datum der Musterfreigabe",
          "sample_hpl_accepted_at": "Datum der Musterfreigabe"
        }
      }
    },
    "servicesPackageHideContents": "Inhalt ausblenden",
    "servicesPackageInvalidConfig": {
      "noMatchingService": "Keine passende Dekoration für die angegebene Konfiguration gefunden",
      "wrongDimensions": "Ungültige Maße für die Dekoration angegeben"
    },
    "servicesPackageModify": "Größe und Komplexitätsgrad der Dekoration ändern",
    "servicesPackageVariant": "Ausgewählte Variante",
    "servicesPackageName": "Name des Dekorationspakets",
    "servicesPackagePopup": {
      "addServicesPackage": "Dekorationspaket hinzufügen",
      "includedServices": "Im ausgewählten Paket enthaltene Dekorationen:",
      "noServicesIncluded": "Dem ausgewählten Dekorationspaket sind keine Dekorationen zugewiesen.",
      "noServicesPackagesMatchingGivenPhrase": "Keine Pakete gefunden, die der eingegebenen Phrase entsprechen",
      "selectServicesPackage": "Dekorationspaket auswählen",
      "title": "Wählen Sie ein hinzuzufügendes Dekorationspaket aus"
    },
    "servicesPackageShowContents": "Inhalt anzeigen",
    "setupPrice": "Setup-Kosten",
    "stitchNumber": "Stichanzahl",
    "strandColors": "Garnfarben",
    "wrongDimensions": "Ungültige Dekorationsmaße",
    "wrongDimensionsDesc": "Bitte geben Sie Breite und Höhe der Dekoration an"
  },
  "settings": {
    "country": {
      "country": "Land",
      "countryCode": "Ländercode",
      "selectCountry": "Land auswählen"
    },
    "currency": {
      "chooseCurrency": "Währung wählen",
      "currency": "Währung",
      "noCurrenciesAvailable": "Keine Währungen verfügbar..."
    },
    "language": {
      "chooseLanguage": "Sprache wählen",
      "noLanguagesAvailable": "Keine Sprachen verfügbar"
    },
    "transaltion": {
      "addTranslation": "Eine Übersetzung hinzufügen",
      "addTranslationErrorText": "Das Hinzufügen einer Übersetzung ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
      "addTranslationSuccessText": "Die eingegebene Übersetzung wurde gespeichert",
      "addTranslationSuccessTitle": "Übersetzung hinzugefügt",
      "deleteTranslationConfirmTitle": "Sind Sie sicher, dass Sie diese Übersetzung löschen wollen?",
      "deleteTranslationErrorText": "Das Löschen der Übersetzung ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
      "deleteTranslationSuccessText": "Die ausgewählte Übersetzung wurde gelöscht",
      "deleteTranslationSuccessTitle": "Übersetzung gelöscht",
      "editTranslation": "Übersetzung bearbeiten",
      "translationEditErrorText": "Bearbeitung der Übersetzung ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
      "translationEditSuccessText": "Die ausgewählte Übersetzung wurde geändert",
      "translationEditSuccessTitle": "Übersetzung geändert",
      "translations": "Übersetzungen"
    }
  },
  "settlements": {
    "amount": "Betrag",
    "deadlines": "Fristen",
    "invoiceList": "Liste der Rechnungen",
    "issued": "Ausgestellt",
    "noSettlementsToDisplay": "Es wurden keine Rechnung zum Anzeigen gefunden",
    "paymentDueDate": "Zu bezahlen bis",
    "settle": "Abrechnen",
    "settled": "Abgerechnet",
    "settlement": "Abrechnung",
    "settlements": "Abrechnungen",
    "type": "Art"
  },
  "shippers": {
    "chooseShipper": "Speditionsunternehmen auswählen",
    "noShippersAvailable": "Keine Speditionsunternehmen verfügbar"
  },
  "status": {
    "status": "Status",
    "statusQuestionMark": "Status?"
  },
  "translation": {
    "editTranslation": "Übersetzung bearbeiten",
    "languageLocative": "Sprache",
    "languagesLocative": "Sprachen",
    "missingTranslationsIn": "Fehlende Übersetzung in ",
    "noTranslationsToDisplay": "Keine Übersetzungen verfügbar...",
    "systemName": "Systemname",
    "translated": "Übersetzt",
    "translationEditErrorText": "Beim Speichern der Änderungen ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut...",
    "translationEditSuccessText": "Änderungen der Übersetzungen gespeichert",
    "translationEditSuccessTitle": "Änderungen gespeichert",
    "translationStatus": "Übersetzungsstatus",
    "translations": "Übersetzungen",
    "translationsTitle": "Übersetzungsliste",
    "valueInPolish": "Auf Polnisch"
  },
  "ui": {
    "actionFailedTryAgain": "Aktion fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "actions": "Aktionen",
    "add": "hinzufügen",
    "addDescription": "Beschreibung hinzufügen",
    "addNew": "Neu hinzufügen",
    "addToCart": "In den Warenkorb",
    "address": "Adresse",
    "allFieldsAreRequired": "Alle Felder müssen ausgefüllt werden.",
    "amount": "Menge",
    "availability": "Verfügbarkeit",
    "back": "Zurück",
    "backToList": "Zurück zur Liste",
    "cancel": "Abbrechen",
    "cart": "Warenkorb",
    "cartIsEmpty": "Ihr Warenkorb ist leer",
    "chooseDate": "Wählen Sie ein Datum",
    "close": "Schließen",
    "companyName": "Firmenname",
    "contactPerson": "Ansprechpartner",
    "createOrderFromCart": "Einen Auftrag aus folgenden Produkten zusammenstellen",
    "dataLoading": "Der Ladevorgang von Daten läuft",
    "dataLoadingFailed": "Das Einlesen der Daten ist fehlgeschlagen.",
    "daysOfWeek": {
      "fri": "Fr",
      "mon": "Mo",
      "sat": "Sa",
      "sun": "So",
      "thur": "Do",
      "tue": "Di",
      "wed": "Mi"
    },
    "deadlinePreferred": "Bevorzugter Termin",
    "delete": "Löschen",
    "deleteConfirmText": "Dieser Vorgang kann nicht rückgängig gemacht werden",
    "downloadInProgress": "Download läuft",
    "duplicate": "Duplizieren",
    "eMailCap": "E-Mail",
    "eMailShort": "E-Mail",
    "edit": "Bearbeiten",
    "emailAddress": "E-Mail Adresse",
    "errorOccured": "Es ist ein Fehler aufgetreten",
    "errorOccuredDuringDownload": "Es ist ein Download-Fehler aufgetreten",
    "filtersSearch": "Suche",
    "generalInfo": "Allgemeine Daten",
    "importErrorTitle": "Es ist ein Fehler beim Imporieren aufgetreten",
    "importFile": "Datei importieren",
    "importType": "Importtyp",
    "inCart": "Im Warenkorb",
    "invoiceNumber": "Rechnungsnummer",
    "isSettled": "Abgerechnet?",
    "lack": "Kann nicht gefunden werden",
    "language": "Sprache",
    "leadingPerson": "Für den Auftrag zuständiger Ansprechpartner",
    "loadError": "FEHLER BEIM EINLESEN DER DATEI",
    "markupProducts": "Aufschlag auf Produkte ",
    "markupServices": "Aufschlag für Dekorationen",
    "markupSetupServices": "Aufschlag auf Dekorationssetup",
    "markupShipping": "Aufschlag auf Lieferkosten",
    "monthNames": {
      "apr": "Apr",
      "aug": "Aug",
      "dec": "Dez",
      "feb": "Feb",
      "jan": "Jan",
      "jul": "Jul",
      "jun": "Jun",
      "mar": "Mär",
      "may": "Mai",
      "nov": "Nov",
      "oct": "Okt",
      "sep": "Sep"
    },
    "myOrders": "Meine Bestellungen",
    "name": "Name",
    "nameAndSurename": "Vor- und Nachname",
    "no": "Keine",
    "noAvailabilityData": "Keine Angaben zur Verfügbarkeit",
    "notSettled": "Offene Rechnung",
    "ok": "OK",
    "okUnderstand": "OK, verstanden",
    "order": "Auftrag",
    "orderName": "Auftragsbezeichnung",
    "pagination": {
      "itemsAmount": "Anzahl der Posten"
    },
    "partnerDiscountProducts": "Kundenrabatt auf Produkte",
    "partnerDiscountServices": "Kundenrabatt auf Dekorationen",
    "partnerDiscountShipping": "Kundenrabatt auf Versand",
    "phoneShort": "Tel.",
    "pieces": "Stück",
    "piecesAbbr": "Stk.",
    "piecesAmount": "Stückzahl",
    "productsGenitive": "Produkte",
    "refNumber": "Referenznummer",
    "refreshPage": "Seite aktualisieren",
    "repeatPassword": "Passwort wiederholen",
    "resetFilters": "Filter zurücksetzen",
    "saveChanges": "Änderungen speichern",
    "search": "Suche",
    "searchFrom": "Suche ab",
    "searchTo": "bis",
    "searching": "Suchvorgang läuft",
    "selectContactPerson": "Ansprechpartner auswählen",
    "selectFile": "Datei auswählen",
    "selectLeadingPerson": "Für den Auftrag zuständigen Ansprechpartner auswählen",
    "selectedPersonNotFound": "Kein Ansprechpartner ausgewählt",
    "settled": "Abgerechnet",
    "shipper": "Speditionsunternehmen",
    "sorting": {
      "asc": "Aufsteigend",
      "availability": "Verfügbarkeit",
      "code": "Produktcode",
      "desc": "Absteigend",
      "label": "Sortieren nach",
      "price": "Preis"
    },
    "supplier": "Lieferant",
    "toTryAgain": "um es erneut zu versuchen.",
    "tryAgain": "Versuchen Sie es erneut",
    "value": "Wert",
    "viewInNewTab": "Siehe neue Registerkarte",
    "yes": "Ja",
    "yesRemove": "Ja, entfernen"
  },
  "users": {
    "accountActive": "Konto aktiv",
    "accountInactive": "Konto nicht aktiv",
    "active": "Aktiv",
    "addUser": "Benutzer hinzufügen",
    "addUserErrorText": "Das Hinzufügen eines Benutzers ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "addUserSuccessText": "Der angegebene Benutzer wurde gespeichert",
    "addUserSuccessTitle": "Benutzer hinzugefügt",
    "addingNewUser": "Benutzer hinzufügen",
    "customer": "Kunde",
    "deleteConfirmTitle": "Sind Sie sicher, dass Sie diesen Benutzer löschen wollen?",
    "deleteErrorText": "Das Löschen des Benutzers ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "deleteSuccessText": "Der ausgewählte Benutzer wurde gelöscht",
    "deleteSuccessTitle": "Benutzer gelöscht",
    "editUser": "Benutzer bearbeiten",
    "editUserErrorText": "Die Bearbeitung des Benutzers ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "editUserSuccessText": "Der ausgewählte Benutzer wurde geändert",
    "editUserSuccessTitle": "Benutzer geändert",
    "inactive": "Inaktiv",
    "isAccountActive": "Konto aktiv?",
    "loggedInAs": "Angemeldet als",
    "noUsersMatchingPhrase": "Keine zu dem angegebenen Suchbegriff passenden Mittarbeiter",
    "noUsersToDisplay": "Keine Benutzer zum Anzeigen vorhanden.",
    "selectWorker": "Mitarbeiter auswählen",
    "usersLabel": "Benutzer",
    "usersList": "Liste der Benutzer",
    "usersSearchPlaceholder": "Geben Sie den Vornamen, Nachnamen oder die E-Mail-Adresse des Benutzers ein."
  },
  "validation": {
    "fieldCanContainAtLeast1Char": "Dieses Feld muss mindestens ein Zeichen enthalten",
    "fieldCanContainAtLeast24Chars": "Dieses Feld muss mindestens {min} Zeichen enthalten",
    "fieldCanContainAtLeastNChars": "Dieses Feld muss mindestens {min} Zeichen enthalten",
    "fieldCanContainAtMax1Char": "Dieses Feld darf maximal ein Zeichen enthalten",
    "fieldCanContainAtMax24Chars": "Dieses Feld kann maximal {max} Zeichen enthalten",
    "fieldCanContainAtMaxNChars": "Dieses Feld kann maximal {max} Zeichen enthalten",
    "onlyBigLetters": "Dieses Feld darf ausschließlich Großbuchstaben enthalten",
    "onlyLettersAndDashes": "Dieses Feld darf ausschließlich Buchstaben und Bindestriche enthalten",
    "onlyLettersAndNumbers": "Dieses Feld darf ausschließlich Buchstaben und Zahlen enthalten",
    "onlyNumbers": "Dieses Feld muss eine Zahl enthalten",
    "onlyIntegerNumbers": "Dieses Feld muss eine ganze Zahl enthalten",
    "passwordsAreNotIdentical": "Passwörter sind nicht identisch",
    "required": "Dieses Feld ist ein Pflichtfeld",
    "validDoubleNumericRequired": "Die erforderliche Zahl muss dem  123.45-Format entsprechen",
    "validEmailRequired": "Dieses Feld muss eine gültige E-Mail Adresse enthalten",
    "validUrlRequired": "Dieses Feld muss eine gültige URL-Adresse enthalten",
    "valueCannotBeGreaterThan": "Der Wert darf nicht größer sein als",
    "valueCannotBeLessThan": "Der Wert darf nicht kleiner sein als",
    "valueMustContainOrderID": "Die Auftragsbezeichnung muss die Auftrags-ID enthalten:",
    "youMustSelectValue": "Sie müssen einen Wert auswählen"
  },
  "welcome": {
    "baseballCaps": "Basecaps",
    "capVizors": "Schirme",
    "choose": "Wählen",
    "clear": "löschen",
    "clientPanel": "Kundenpanel",
    "companyName": "Headwear",
    "filter": "Filter anwenden",
    "filterAvailability": "Nach Verfügbarkeit filtern",
    "filterByNameOrCode": "Nach Name/Code filtern",
    "filterByPrice": "Nach Preis filtern",
    "hats": "Hüte",
    "noProductsInSearchCriteria": "Keine Produkte, die den eingegebenen Kriterien entsprechen",
    "orderBy": "Sortieren nach",
    "orderInfo": "Schließen Sie Ihren Auftrag <span class=„text-primary font-weight-bold“>in 5 einfachen Schritten</span> ab:",
    "productBrowserInfo": "Nutzen Sie unsere <span class=\"font-weight-bold\">Produkt-Suchmaschine</span>. Hier finden Sie Produktbilder, den Preis und den Lagerbestand. Sie können Ihren Auftrag auch aus der Ebene der Suchmaschine erstellen. Klicken Sie einfach beim jeweiligenProdukt auf <span class=„font-weight-bold“>„In den Warenkorb“</span>. Sie können dann den gesamten Warenkorb zu Ihrem Auftrag hinzufügen.",
    "requireAll": "Alles abrufen",
    "searchProducts": "Produkt suchen",
    "setp": "Schritt",
    "stepFiveContent": "Klicken Sie auf  den Button <span class=„font-weight-bold“>„Angebot speichern“</span> oder <span class=„font-weight-bold“>„Auftrag zur Bearbeitung abschicken“.",
    "stepFourContent": "Geben Sie in der Registerkarte <span class=„font-weight-bold“>„Allgemeine Daten“</span> die Liefer- und Kontaktdaten ein",
    "stepOneContent": "Gehen Sie zur Registerkarte <span class=„font-weight-bold“>„Aufträge“</span>.",
    "stepThreeContent": "In der Registerkarte <span class=„font-weight-bold“>  ählen Sie unter \"Auftrag“</span> Produkte und Dekorationen aus",
    "stepTwoContent": "Klicken Sie auf <span class=„font-weight-bold“>„Hinzufügen“</span>.",
    "wantToCheckOurProducts": "Möchten Sie unsere Produkte und Preise schnell überprüfen?",
    "welcomeToClientPanel": "Willkommen im HeadWear- Kundenpanel",
    "winterHats": "Wintermützen"
  }
};
